import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { DropDown } from 'src/app/interfaces/drop-down.interface';
import { OrganizationService } from 'src/app/services/organization.service';

export const ORGANIZATION_FORM_CONTROL_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => OrganizationFormFieldComponent),
  multi: true,
};

@Component({
  selector: 'app-organization-form-field',
  providers: [ORGANIZATION_FORM_CONTROL_ACCESSOR],
  templateUrl: './organization-form-field.component.html',
  styleUrls: ['./organization-form-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationFormFieldComponent
  implements ControlValueAccessor, OnChanges, AfterViewInit
{
  @ViewChild('organizationField') organizationField: DropDownList;
  @Input() orgId: number = null;
  @Input() includeChildOrgs: boolean = null;

  options: DropDown<string>[] = null;
  fields: Object = { value: 'value', text: 'text' };
  loading: boolean = false;
  _value: DropDown<number> | null = null;

  constructor(
    private _os: OrganizationService,
    private _cdr: ChangeDetectorRef,
  ) {}

  private _disabled: boolean = false;
  public get disabled(): boolean {
    return this._disabled || this.loading;
  }
  public set disabled(value: boolean) {
    this._disabled = value;
  }

  ngAfterViewInit(): void {
    this.updateOrganizationField();
  }

  private updateOrganizationField() {
    if (this.organizationField) {
      if(this._value?.value){
        this.organizationField.value = this._value?.value ?? null;
      }
      else {
        this.organizationField.index = null;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // If the organization ID changes, reload the options.
    if (this.orgId) {
      this.loadOptions();
    }
  }

  onOrganizationChanged($event) {
    this._value = $event.itemData;
    this.onTouched();
    this.onChange(this._value);
  }

  // Function to call when the input changes.
  onChange = (value: DropDown<number>) => {};

  // Function to call when the input is touched.
  onTouched = () => {};

  private loadOptions() {
    this.loading = true;
    this._cdr.markForCheck();
    this._os
      .getOrganizationDropDownByParentId(this.orgId)
      .subscribe((orgs) => {
        this.options = orgs;
        this.loading = false;
        this._cdr.markForCheck();
      });
  }

  // Allows Angular to update the model (organizationControl).
  // Update the model and changes needed for the view here.
  writeValue(value: DropDown<number>): void {
    this._value = value;
    this.updateOrganizationField();
    this.onChange(value);
  }

  // Allows Angular to register a function to call when the model (organizationControl) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this._cdr.markForCheck();
  }

}
